(function ( $ ) {
    (function () {
        $("#password-reset-send-email").submit(function (e) {
            e.preventDefault();
            let email = $("#password-reset-send-email [name=\"email\"]").val();
            let phoneNumber = $("#password-reset-send-email [name=\"phoneNumber\"]").val();
            let token = $('meta[name="csrf-token"]').attr('content');

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .post(`/password/email`, {
                    email: email,
                    phoneNumber: phoneNumber,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $('#password-reset-send-email .response').html(response.data.message);
                })
                .catch(error => {
                    let errors = error.response.data.errors;
                    console.log(errors);
                    if (error.response.status === 503) {
                        $('#password-reset-send-email .edit-error-email').html(error.response.data.errors);
                    }
                    if (errors.hasOwnProperty('email')) {
                        $('#password-reset-send-email .edit-error-email').html(errors.email.join(', '));
                    }
                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });

        $("#password-reset").submit(function (e) {
            e.preventDefault();
            let url_string = window.location.href;
            let url = new URL(url_string);
            let email = url.searchParams.get("email");
            let password = $("#password-reset [name=\"password\"]").val();
            let pathArray = window.location.pathname.split('/');

            const lang = pathArray[1];
            var token = (lang === "ua") ? pathArray[4] : pathArray[3];
            console.log(token);
            let csrf_token = $('meta[name="csrf-token"]').attr('content');

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .post(`/password/reset`, {
                    email: email,
                    password: password,
                    token: token,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': csrf_token
                    }
                })
                .then(response => {
                    // console.log(response.data);
                    $('#password-reset .response').html(response.data.message);
                })
                .catch(error => {
                    let errors = error.response.data.errors;
                    console.log(errors);
                    let message = '';
                    for (const property in errors) {
                        console.log(property);
                        message = errors[property].join(', ') + "<br/>";
                    }
                    if (message.length) {
                        $('#password-reset .edit-error-password').html(message);
                    }
                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });
    }());

}( jQuery ));


